import { Module, MutationTree, ActionTree, GetterTree } from 'vuex';

export class UserState {
  public client: api.client.getInfo.client = {
    name: '',
    email: '',
    phoneNumber: '',
    joinType: 'normal',
  };

  public center: api.client.getInfo.center = {
    centerId: '',
    jibunAddress: '',
    roadAddress: '',
    detailAddress: '',
    dongName: '',
    latitude: 0,
    longitude: 0,
    postalCode: '',
    detailAddressEng: '',
    jibunAddressEng: '',
    roadAddressEng: '',
  };

  public group: api.client.getInfo.group = {
    groupId: null,
    memberRole: '',
    memberStatus: '',
  };

  public unit: api.client.getInfo.clientUnitInfo = {
    participantUnitId: null,
    unitRole: '',
    groupRoles: [''],
    pendingGroups: [],
    clientId: '',
  };

  public tos: api.client.getInfo.tos = {
    marketing: null,
  };
}

const Mutations: MutationTree<UserState> = {
  updateClient(state, payload) {
    state.client = payload;
  },
  updateCenter(state, payload) {
    state.center = payload;
  },
  updateGroup(state, payload) {
    state.group = payload;
  },
  updateMarketing(state, payload) {
    state.tos.marketing = payload;
  },
  updateUnit(state, payload) {
    state.unit = payload.clientUnitInfo;
  },
};
const Actions: ActionTree<UserState, any> = {
  updateClient({ commit }, payload) {
    commit('updateClient', payload);
  },
  updateCenter({ commit }, payload) {
    commit('updateCenter', payload);
  },
  updateGroup({ commit }, payload) {
    commit('updateGroup', payload);
  },
  updateUnit({ commit }, payload) {
    commit('updateUnit', payload);
  },
  updateMarketing({ commit }, payload) {
    commit('updateMarketing', payload);
  },
  resetClient({ commit }) {
    commit('updateClient', {
      name: '',
      email: '',
      phoneNumber: '',
      joinType: 'normal',
    });
  },
  resetCenter({ commit }) {
    commit('updateCenter', {
      centerId: '',
      jibunAddress: '',
      roadAddress: '',
      detailAddress: '',
      dongName: '',
      latitude: 0,
      longitude: 0,
      postalCode: '',
    });
  },
  resetGroup({ commit }) {
    commit('updateGroup', {
      groupId: null,
      memberRole: '',
      memberStatus: '',
    });
  },
  resetMarketing({ commit }) {
    commit('updateMarketing', null);
  },
  resetUnit({ commit }) {
    commit('updateUnit', {
      participantUnitId: null,
      unitRole: '',
      groupRoles: [''],
      pendingGroups: [],
    });
  },
};
const Getters: GetterTree<UserState, any> = {};

const module: Module<UserState, any> = {
  namespaced: true,
  state: new UserState(),
  mutations: Mutations,
  actions: Actions,
  getters: Getters,
};

export default module;
